/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import { withLocalization } from 'hocs/localization'
import { getSubscriptionPlans, getSelectedPlanId, isSelectedPlanAvailable } from 'redux-app/selectors/subscription'
import CreateProfile from './CreateProfile'

export default compose(
  withLocalization('profile.create'),
  connect(
    state => ({
      selectedPlanId: getSelectedPlanId(state),
      plan: getSubscriptionPlans(state).find(plan => plan.id === getSelectedPlanId(state)),
      isSelectedPlanAvailable: isSelectedPlanAvailable(state),
    }),
    null,
  ),
  withRouter,
  lifecycle({
    componentWillMount () {
      if (!this.props.selectedPlanId || !this.props.isSelectedPlanAvailable) {
        this.props.history.replace(ROUTES.home.home)
      }
    },
  }),
)(CreateProfile)
